import { render } from "./create-live-classes.vue?vue&type=template&id=050de300"
import script from "./create-live-classes.vue?vue&type=script&lang=js"
export * from "./create-live-classes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__